import '@angular/localize/init';
import 'core-js/stable/reflect';
import 'zone.js';